import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { concat, fn } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import { service } from "@ember/service";
import { TrackedSet } from "@ember-compat/tracked-built-ins";
import { gt, has, or } from "truth-helpers";
import ConditionalLoadingSpinner from "discourse/components/conditional-loading-spinner";
import loadingSpinner from "discourse/helpers/loading-spinner";
import { popupAjaxError } from "discourse/lib/ajax-error";
import { INPUT_DELAY } from "discourse-common/config/environment";
import i18n from "discourse-common/helpers/i18n";
import discourseDebounce from "discourse-common/lib/debounce";
import EditNavigationMenuModal from "./modal";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
export default class SidebarEditNavigationMenuTagsModal extends Component {
  static #_ = (() => dt7948.g(this.prototype, "currentUser", [service]))();
  #currentUser = (() => (dt7948.i(this, "currentUser"), void 0))();
  static #_2 = (() => dt7948.g(this.prototype, "siteSettings", [service]))();
  #siteSettings = (() => (dt7948.i(this, "siteSettings"), void 0))();
  static #_3 = (() => dt7948.g(this.prototype, "store", [service]))();
  #store = (() => (dt7948.i(this, "store"), void 0))();
  static #_4 = (() => dt7948.g(this.prototype, "disableFiltering", [tracked], function () {
    return false;
  }))();
  #disableFiltering = (() => (dt7948.i(this, "disableFiltering"), void 0))();
  static #_5 = (() => dt7948.g(this.prototype, "saving", [tracked], function () {
    return false;
  }))();
  #saving = (() => (dt7948.i(this, "saving"), void 0))();
  static #_6 = (() => dt7948.g(this.prototype, "selectedTags", [tracked], function () {
    return new TrackedSet([...this.currentUser.sidebarTagNames]);
  }))();
  #selectedTags = (() => (dt7948.i(this, "selectedTags"), void 0))();
  static #_7 = (() => dt7948.g(this.prototype, "tags", [tracked], function () {
    return [];
  }))();
  #tags = (() => (dt7948.i(this, "tags"), void 0))();
  static #_8 = (() => dt7948.g(this.prototype, "tagsLoading", [tracked], function () {
    return false;
  }))();
  #tagsLoading = (() => (dt7948.i(this, "tagsLoading"), void 0))();
  observer;
  onlySelected = false;
  onlyUnselected = false;
  constructor() {
    super(...arguments);
    this.#loadTags();
  }
  async #loadTags() {
    this.tagsLoading = true;
    const findArgs1 = {};
    if (this.filter) {
      findArgs1.filter = this.filter;
    }
    if (this.onlySelected) {
      findArgs1.only_tags = [...this.selectedTags].join(",");
    } else if (this.onlyUnselected) {
      findArgs1.exclude_tags = [...this.selectedTags].join(",");
    }
    try {
      const tags1 = await this.store.findAll("listTag", findArgs1);
      this.tags = tags1;
    } catch (error1) {
      popupAjaxError(error1);
    } finally {
      this.tagsLoading = false;
      this.disableFiltering = false;
    }
  }
  didInsertTag(element1) {
    const tagName1 = element1.dataset.tagName;
    const lastTagName1 = this.tags.content[this.tags.content.length - 1].name;
    if (tagName1 === lastTagName1) {
      if (this.observer) {
        this.observer.disconnect();
      } else {
        const root1 = document.querySelector(".d-modal__body");
        const style1 = window.getComputedStyle(root1);
        const marginTop1 = parseFloat(style1.marginTop);
        const paddingTop1 = parseFloat(style1.paddingTop);
        this.observer = new IntersectionObserver(entries1 => {
          entries1.forEach(entry1 => {
            if (entry1.isIntersecting) {
              this.tags.loadMore();
            }
          });
        }, {
          root: document.querySelector(".d-modal__body"),
          rootMargin: `0px 0px ${marginTop1 + paddingTop1}px 0px`,
          threshold: 1.0
        });
      }
      this.observer.observe(element1);
    }
  }
  static #_9 = (() => dt7948.n(this.prototype, "didInsertTag", [action]))();
  resetFilter() {
    this.onlySelected = false;
    this.onlyUnselected = false;
    this.#loadTags();
  }
  static #_10 = (() => dt7948.n(this.prototype, "resetFilter", [action]))();
  filterSelected() {
    this.onlySelected = true;
    this.onlyUnselected = false;
    this.#loadTags();
  }
  static #_11 = (() => dt7948.n(this.prototype, "filterSelected", [action]))();
  filterUnselected() {
    this.onlySelected = false;
    this.onlyUnselected = true;
    this.#loadTags();
  }
  static #_12 = (() => dt7948.n(this.prototype, "filterUnselected", [action]))();
  onFilterInput(filter1) {
    this.disableFiltering = true;
    discourseDebounce(this, this.#performFiltering, filter1, INPUT_DELAY);
  }
  static #_13 = (() => dt7948.n(this.prototype, "onFilterInput", [action]))();
  #performFiltering(filter1) {
    this.filter = filter1.toLowerCase();
    this.#loadTags();
  }
  deselectAll() {
    this.selectedTags.clear();
  }
  static #_14 = (() => dt7948.n(this.prototype, "deselectAll", [action]))();
  resetToDefaults() {
    this.selectedTags = new TrackedSet(this.siteSettings.default_navigation_menu_tags.split("|"));
  }
  static #_15 = (() => dt7948.n(this.prototype, "resetToDefaults", [action]))();
  toggleTag(tag1) {
    if (this.selectedTags.has(tag1)) {
      this.selectedTags.delete(tag1);
    } else {
      this.selectedTags.add(tag1);
    }
  }
  static #_16 = (() => dt7948.n(this.prototype, "toggleTag", [action]))();
  async save() {
    this.saving = true;
    const initialSidebarTags1 = this.currentUser.sidebar_tags;
    this.currentUser.set("sidebar_tag_names", [...this.selectedTags]);
    try {
      const result1 = await this.currentUser.save(["sidebar_tag_names"]);
      this.currentUser.set("sidebar_tags", result1.user.sidebar_tags);
      this.args.closeModal();
    } catch (error1) {
      this.currentUser.set("sidebar_tags", initialSidebarTags1);
      popupAjaxError(error1);
    } finally {
      this.saving = false;
    }
  }
  static #_17 = (() => dt7948.n(this.prototype, "save", [action]))();
  static #_18 = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      <EditNavigationMenuModal
        @title="sidebar.tags_form_modal.title"
        @saving={{this.saving}}
        @save={{this.save}}
        @showResetDefaultsButton={{gt
          this.siteSettings.default_navigation_menu_tags.length
          0
        }}
        @resetToDefaults={{this.resetToDefaults}}
        @deselectAll={{this.deselectAll}}
        @deselectAllText={{i18n "sidebar.tags_form_modal.subtitle.text"}}
        @inputFilterPlaceholder={{i18n
          "sidebar.tags_form_modal.filter_placeholder"
        }}
        @onFilterInput={{this.onFilterInput}}
        @resetFilter={{this.resetFilter}}
        @filterSelected={{this.filterSelected}}
        @filterUnselected={{this.filterUnselected}}
        @closeModal={{@closeModal}}
        @loading={{or this.tagsLoading this.disableFiltering}}
        class="sidebar__edit-navigation-menu__tags-modal"
      >
        {{#if this.tagsLoading}}
          {{loadingSpinner size="large"}}
        {{else}}
          <form class="sidebar-tags-form">
            {{#each this.tags as |tag|}}
              <div
                {{didInsert this.didInsertTag}}
                data-tag-name={{tag.name}}
                class="sidebar-tags-form__tag"
              >
                <input
                  {{on "click" (fn this.toggleTag tag.name)}}
                  type="checkbox"
                  checked={{has this.selectedTags tag.name}}
                  id={{concat "sidebar-tags-form__input--" tag.name}}
                  class="sidebar-tags-form__input"
                />
  
                <label
                  for={{concat "sidebar-tags-form__input--" tag.name}}
                  class="sidebar-tags-form__tag-label"
                >
                  <p>
                    <span class="sidebar-tags-form__tag-label-name">
                      {{tag.name}}
                    </span>
  
                    <span class="sidebar-tags-form__tag-label-count">
                      ({{tag.topic_count}})
                    </span>
                  </p>
                </label>
              </div>
            {{else}}
              <div class="sidebar-tags-form__no-tags">
                {{i18n "sidebar.tags_form_modal.no_tags"}}
              </div>
            {{/each}}
          </form>
        {{/if}}
  
        <ConditionalLoadingSpinner @condition={{this.tags.loadingMore}} />
      </EditNavigationMenuModal>
    
  */
  {
    "id": "Xjff1B9E",
    "block": "[[[1,\"\\n    \"],[8,[32,0],[[24,0,\"sidebar__edit-navigation-menu__tags-modal\"]],[[\"@title\",\"@saving\",\"@save\",\"@showResetDefaultsButton\",\"@resetToDefaults\",\"@deselectAll\",\"@deselectAllText\",\"@inputFilterPlaceholder\",\"@onFilterInput\",\"@resetFilter\",\"@filterSelected\",\"@filterUnselected\",\"@closeModal\",\"@loading\"],[\"sidebar.tags_form_modal.title\",[30,0,[\"saving\"]],[30,0,[\"save\"]],[28,[32,1],[[30,0,[\"siteSettings\",\"default_navigation_menu_tags\",\"length\"]],0],null],[30,0,[\"resetToDefaults\"]],[30,0,[\"deselectAll\"]],[28,[32,2],[\"sidebar.tags_form_modal.subtitle.text\"],null],[28,[32,2],[\"sidebar.tags_form_modal.filter_placeholder\"],null],[30,0,[\"onFilterInput\"]],[30,0,[\"resetFilter\"]],[30,0,[\"filterSelected\"]],[30,0,[\"filterUnselected\"]],[30,1],[28,[32,3],[[30,0,[\"tagsLoading\"]],[30,0,[\"disableFiltering\"]]],null]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"tagsLoading\"]],[[[1,\"        \"],[1,[28,[32,4],null,[[\"size\"],[\"large\"]]]],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,\"form\"],[14,0,\"sidebar-tags-form\"],[12],[1,\"\\n\"],[42,[28,[31,2],[[28,[31,2],[[30,0,[\"tags\"]]],null]],null],null,[[[1,\"            \"],[11,0],[16,\"data-tag-name\",[30,2,[\"name\"]]],[24,0,\"sidebar-tags-form__tag\"],[4,[32,5],[[30,0,[\"didInsertTag\"]]],null],[12],[1,\"\\n              \"],[11,\"input\"],[16,\"checked\",[28,[32,6],[[30,0,[\"selectedTags\"]],[30,2,[\"name\"]]],null]],[16,1,[28,[32,7],[\"sidebar-tags-form__input--\",[30,2,[\"name\"]]],null]],[24,0,\"sidebar-tags-form__input\"],[24,4,\"checkbox\"],[4,[32,8],[\"click\",[28,[32,9],[[30,0,[\"toggleTag\"]],[30,2,[\"name\"]]],null]],null],[12],[13],[1,\"\\n\\n              \"],[10,\"label\"],[15,\"for\",[28,[32,7],[\"sidebar-tags-form__input--\",[30,2,[\"name\"]]],null]],[14,0,\"sidebar-tags-form__tag-label\"],[12],[1,\"\\n                \"],[10,2],[12],[1,\"\\n                  \"],[10,1],[14,0,\"sidebar-tags-form__tag-label-name\"],[12],[1,\"\\n                    \"],[1,[30,2,[\"name\"]]],[1,\"\\n                  \"],[13],[1,\"\\n\\n                  \"],[10,1],[14,0,\"sidebar-tags-form__tag-label-count\"],[12],[1,\"\\n                    (\"],[1,[30,2,[\"topic_count\"]]],[1,\")\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[2]],[[[1,\"            \"],[10,0],[14,0,\"sidebar-tags-form__no-tags\"],[12],[1,\"\\n              \"],[1,[28,[32,2],[\"sidebar.tags_form_modal.no_tags\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n      \"],[8,[32,10],null,[[\"@condition\"],[[30,0,[\"tags\",\"loadingMore\"]]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[\"@closeModal\",\"tag\"],false,[\"if\",\"each\",\"-track-array\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/sidebar/edit-navigation-menu/tags-modal.js",
    "scope": () => [EditNavigationMenuModal, gt, i18n, or, loadingSpinner, didInsert, has, concat, on, fn, ConditionalLoadingSpinner],
    "isStrictMode": true
  }), this))();
}